/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Pagination, RequestParams } from '~core/models/core.models';
import { CreateUnitMeasureParams, Tax } from '~core/models/core.models';
import { UNIT_MEASURE_URL } from '../constants/api.constants';

@Injectable()
export class TaxService {
  private _httpClient = inject(HttpClient);

  read(userId: string): Observable<Tax> {
    return this._httpClient.get<Tax>(`${UNIT_MEASURE_URL}/${userId}`);
  }

  list(
    params?: RequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<Tax>> {
    return this._httpClient.get<Pagination<Tax>>(UNIT_MEASURE_URL, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  create(data: CreateUnitMeasureParams): Observable<Tax> {
    return this._httpClient.post<Tax>(UNIT_MEASURE_URL, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(id: string, data: Partial<CreateUnitMeasureParams>): Observable<Tax> {
    return this._httpClient.patch<Tax>(`${UNIT_MEASURE_URL}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  remove(taxId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(`${UNIT_MEASURE_URL}/${taxId}`);
  }
}
